import React from 'react';

import './styles.css';

import { useHistory } from "react-router-dom";
import { FaChevronLeft } from 'react-icons/fa';

export default function NavHistory(props) {
    let history = useHistory();

    return(
        <nav className='nav-history-view'>
            <button onClick={() => history.goBack()}>
                <FaChevronLeft/>
            </button>
            <div>
                {
                    props.navPages.map((item, index) => 
                    <p key={index}>
                        {index ? '\\':''}{item}
                    </p>
                    )
                }
            </div>
        </nav>
    )
}
